import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import styled, { withTheme } from 'styled-components'
import { CardContainer } from '../Reusable/CardContainer'
import { Flex, FlexColumn } from '../../Reusable/Container'
import environment from '../../../environment'

import AppIcon from '../../../Images/product-menu/CardsActive.png'
import { apiPOSTReq, trackEvent } from '../../../Utils/api'
import CardHeader from '../Reusable/CardHeader'
import ARAgingChart from '../Reusable/ARAgingChart'
import ARAgingCustomer from '../Reusable/ARAgingCustomer'
import LucideIcon, { TextButton } from '../../Reusable/Button'
import { Image } from '../../Reusable/Image'
import ArrowRight from "../../../Images/arrow-right.png"
import DashSpendCard from "../../../Images/dash-spend-card.svg"
import { Text } from '../../Reusable/Text'
import { isMobile, toCurrency } from '../../../Utils/util'
import CardSpendDonutChart from '../Reusable/CardSpendDonutChart'
import CardSpendList from '../Reusable/CardSpendList'
import { CreditCard } from 'lucide-react'
import hexToRgba from 'hex-to-rgba'

class CardSpend extends Component {
    state = {
        loading: true,
        emptyStateCard: false
    }

    componentDidMount() {
        this.fetchData()
    }

    fetchData = () => {
        apiPOSTReq(`${environment.bbBaseUrl}/dashboard/compareBusinessCardSpend`, {}, null, (err, resp) => {
            try {
                this.setState({ loading: false })
                const data = resp || {}
                if (data.result) {
                    if (err) throw new Error(err)
                    console.log("CardSpendDonutChart fetchData", data.cardSpendReport?.spendByCard)
                    var chartData = data.cardSpendReport?.spendByCard?.map(cardSpend => {
                        return {
                            name: cardSpend?.card?.nickName,
                            value: cardSpend?.total
                        }
                    });
                    this.setState({ spendData: data, chartData, emptyStateCard: ((data.cardSpendReport?.total + data.cardSpendReport?.previousPeriodTotal) == 0) })
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getAccounts", error, err, resp)
            }
        })
    }

    render() {
        const { store, theme, small } = this.props;
        const { spendData, chartData, emptyStateCard } = this.state;

        var showChart = isMobile || !small;

        if(!emptyStateCard)
            return (
                <CardContainer small={small}>
                    <FlexColumn>
                        <CardHeader 
                            imgSrc={AppIcon}
                            titleText='Cards' 
                            desc='Month to date spend'
                            path='cards/all'
                            secondaryContent={
                                <FlexColumn centerVertically>
                                    {spendData?.cardSpendReport && <Text size='16px'>This month: <span style={{ fontWeight: 600 }}>${toCurrency(spendData?.cardSpendReport?.total)}</span></Text>}
                                    {spendData?.cardSpendReport && <TextButton 
                                                                        onClick={() => {
                                                                            trackEvent({ name: "dashboard_cta", property: 'manage cards' });
                                                                            this.props.history.push('cards/all');
                                                                        }}
                                                                        rightIcon={<Image src={ArrowRight} />} text="MANAGE" 
                                                                    />}
                                </FlexColumn>
                            }
                        />
                        <Flex wrap={small}>
                            {showChart && (chartData || []).length > 0 && <CardSpendDonutChart data={chartData} />}
                            {spendData && <CardSpendList cardSpendReport={spendData?.cardSpendReport} />  }
                        </Flex>
                        
                    </FlexColumn>
                </CardContainer>
            )
        else
            return (
                <CardContainer small={small} style={{ position: 'relative' }}>
                    <Text weight={600} size='24px' color={this.props.theme.colors.primary2}  style={{ position: 'absolute', top: 30, left: 40 }}>
                        Cards
                    </Text>
                    <Flex fullHeight between centerH>
                        <FlexColumn center gap='8px' style={{ padding: small ? '40px' : '0 0 0 80px', height: 400 }}>
                            <FlexColumn center gap='8px' style={{ padding: '10px' }}>
                                <LucideIcon icon={CreditCard} color={theme.colors.primary} size={24} />
                                <Text heading weight={600}>Expenses simplified</Text>
                                <Text center>Issue, track, monitor and control all card spend in one place.</Text>
                                <TextButton 
                                    onClick={() => {
                                        trackEvent({ name: "dashboard_cta", property: 'issue card' });
                                        this.props.history.push('cards/issue-card');
                                    }} 
                                    rightIcon={<Image src={ArrowRight} />} 
                                    text="ISSUE CARD" 
                                />
                            </FlexColumn>
                            
                        </FlexColumn>
                        {!small && <img height={400} style={{ borderRadius: '24px', position: 'absolute', top: 0, right: 0, bottom: 0 }} src={DashSpendCard} />}
                    </Flex>
                </CardContainer>
            )
    }
}

function mapStateToProps(state) {
    return {
        store: state.aionAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(CardSpend)))